import { z } from "zod";

const boolish = z
  .union([z.literal("true"), z.literal("false"), z.literal("")])
  .default("false")
  .transform((v) => v === "true");

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url().default("http://localhost:5003/v1"),
  // Base do serviço central de notificações (imobgo-notifications, já inclui `/v1`).
  // Vazio = mantém o comportamento anterior (backoffice-api: caminho relativo /
  // VITE_API_BASE_URL), bom para dev local + mock.
  VITE_NOTIFICATIONS_API_BASE_URL: z.string().default(""),
  VITE_AUTH_REALM: z.string().default("backoffice"),

  VITE_MOCK_AUTH: boolish,
  VITE_MOCK_DASHBOARD: boolish,
  VITE_MOCK_METRICS: boolish,
  VITE_MOCK_ORGANIZATIONS: boolish,
  VITE_MOCK_BROKERS: boolish,
  VITE_MOCK_DEVELOPERS: boolish,
  VITE_MOCK_LAUNCH_REGISTRATIONS: boolish,
  VITE_MOCK_AGENCY_REGISTRATIONS: boolish,
  VITE_MOCK_PLANS: boolish,
  VITE_MOCK_LEGAL: boolish,
  VITE_MOCK_SUBSCRIPTIONS: boolish,
  VITE_MOCK_PAYMENTS: boolish,
  VITE_MOCK_WITHDRAWALS: boolish,
  VITE_MOCK_LEDGER: boolish,
  VITE_MOCK_FINANCE: boolish,
  VITE_MOCK_REFERRALS: boolish,
  VITE_MOCK_ADMIN_USERS: boolish,
  VITE_MOCK_AUDIT: boolish,
  VITE_MOCK_SUPPORT: boolish,
  VITE_MOCK_SETTINGS: boolish,
  VITE_MOCK_INTEGRATIONS: boolish,
  VITE_MOCK_SITE_CONTENT: boolish,
  VITE_MOCK_NOTIFICATIONS: boolish,
  VITE_MOCK_ACCOUNT_INVITES: boolish,
  VITE_MOCK_AFFILIATES: boolish,

  VITE_SENTRY_DSN: z.string().default(""),
  VITE_SENTRY_ENVIRONMENT: z.string().default(""),
  VITE_SENTRY_RELEASE: z.string().default(""),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("[env] invalid environment:", parsed.error.flatten().fieldErrors);
  throw new Error("Variáveis de ambiente inválidas. Veja o console.");
}

export const env = parsed.data;
export type Env = typeof env;
